import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.8",
  "description": "Turborepo 1.8은 워크스페이스에 대한 turbo의 이해를 개선하여 코드베이스에 더 나은 유연성과 더 많은 제어를 제공합니다.",
  "date": "2023/02/22",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.8은 turbo의 워크스페이스 이해를 개선하여 코드베이스에 더 나은 유연성과 더 많은 제어를 제공합니다."
  }, {
    "heading": "",
    "content": "워크스페이스 구성: 이제 워크스페이스에 turbo.json 구성 파일을 추가하여 저장소의 루트 구성을 재정의할 수 있습니다."
  }, {
    "heading": "",
    "content": "자동 워크스페이스 범위 지정: 이제 전역 turbo가 현재 워크스페이스를 자동으로 추론하여 해당 워크스페이스의 작업만 실행합니다."
  }, {
    "heading": "",
    "content": "더 쉬운 마이그레이션: npx @turbo/codemod migrate를 사용하여 turbo의 새 버전으로 자동 마이그레이션합니다."
  }, {
    "heading": "",
    "content": "npx @turbo/codemod migrate를 실행하여 오늘 업데이트하세요."
  }, {
    "heading": "워크스페이스-구성",
    "content": "워크스페이스 디렉토리에서 이제 turbo.json을 추가하여 다음을 수행할 수 있습니다:"
  }, {
    "heading": "워크스페이스-구성",
    "content": "해당 워크스페이스에 특정한 작업 추가"
  }, {
    "heading": "워크스페이스-구성",
    "content": "작업에 대한 구성 재정의"
  }, {
    "heading": "워크스페이스-구성",
    "content": "이를 통해 팀은 전역 구성에서 벗어나 워크스페이스의 작업에 대한 세밀한 제어로 이동하여 모노레포의 프로젝트 소유권을 확장할 수 있습니다."
  }, {
    "heading": "워크스페이스-구성",
    "content": "예를 들어, 모노레포에 Next.js 앱과 SvelteKit 앱이 있고 Turborepo를 사용하여 build 작업의 출력을 캐시하려고 한다고 상상해보세요. Next.js build 스크립트는 .next 디렉토리를 생성하는 반면 SvelteKit은 .svelte-kit 디렉토리를 생성합니다. 루트 outputs에 두 빌드 디렉토리를 모두 추가하는 대신 워크스페이스에서 outputs 키를 정의할 수 있습니다:"
  }, {
    "heading": "워크스페이스-구성",
    "content": "워크스페이스 구성의 extends 키를 사용하면 워크스페이스 소유자가 루트 turbo.json의 장점을 사용하고 앱을 다르게 만드는 부분을 사용자 정의할 수 있습니다(\"//\" 기호는 루트에서 실행할 작업 정의에 익숙한 경우 익숙할 것입니다)."
  }, {
    "heading": "워크스페이스-구성",
    "content": "선언된 키는 해당 키가 존재하는 경우 루트의 키를 대체하여 루트 구성에 정의된 내용을 재정의합니다. 선언되지 않은 키는 루트 구성에서 상속됩니다."
  }, {
    "heading": "워크스페이스-구성",
    "content": "위의 예에서 outputs는 두 앱 모두에 대해 사용자 정의되는 반면 dependsOn은 루트 turbo.json에 의해 구성되고 \"^codegen\"으로 유지됩니다."
  }, {
    "heading": "워크스페이스-구성",
    "content": "문서에서 자세히 알아보기."
  }, {
    "heading": "자동-워크스페이스-범위-지정",
    "content": "Turborepo v1.7에서 turbo는 전역으로 설치할 수 있게 되어 코드베이스의 어디에서나 작업을 실행할 수 있는 권한을 제공했습니다. 그러나 turbo는 여전히 루트에서 작업을 실행하여 실행하려고 의도하지 않았을 수 있는 다른 워크스페이스의 작업을 실행했습니다."
  }, {
    "heading": "자동-워크스페이스-범위-지정",
    "content": "1.8에서 turbo는 현재 작업 중인 워크스페이스를 자동으로 감지하고 --filter 구문을 생성하여 해당 워크스페이스로 작업 범위를 지정합니다."
  }, {
    "heading": "자동-워크스페이스-범위-지정",
    "content": "예를 들어, 현재 디렉토리가 apps/admin이고 turbo build 명령을 사용하는 경우 turbo는 후드 아래에서 turbo build --filter=admin을 실행하여 작업 중인 워크스페이스에 집중합니다."
  }, {
    "heading": "더-쉬운-마이그레이션",
    "content": "Turborepo 버전을 업그레이드할 때 올바른 순서로 개별 codemod를 수동으로 실행할 필요가 없습니다. @turbo/codemod는 이제 저장소를 지정된 버전(기본적으로 latest)의 turbo로 업그레이드하고 필요한 모든 codemod를 실행하는 간단한 migrate 명령을 제공합니다."
  }, {
    "heading": "더-쉬운-마이그레이션",
    "content": "지금 npx @turbo/codemod migrate로 사용해 보세요."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo v1.7을 출시한 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"
  }, {
    "heading": "커뮤니티",
    "content": "19.6k+ GitHub Stars"
  }, {
    "heading": "커뮤니티",
    "content": "주간 NPM 다운로드 987k"
  }, {
    "heading": "커뮤니티",
    "content": "Vercel의 Remote Caching을 통해 42년의 컴퓨팅 시간 절약"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo를 여러분의 선택한 빌드 도구로 만들기 위한 지속적인 지원, 피드백 및 협력에 감사드립니다."
  }],
  "headings": [{
    "id": "워크스페이스-구성",
    "content": "워크스페이스 구성"
  }, {
    "id": "자동-워크스페이스-범위-지정",
    "content": "자동 워크스페이스 범위 지정"
  }, {
    "id": "더-쉬운-마이그레이션",
    "content": "더 쉬운 마이그레이션"
  }, {
    "id": "커뮤니티",
    "content": "커뮤니티"
  }]
};
import {Tabs, Tab} from '#components/tabs';
import {Authors} from '#components/authors';
import {Badge} from '#components/badge';
import {Date} from '#components/blog/date';
export const toc = [{
  depth: 2,
  url: "#워크스페이스-구성",
  title: _jsx(_Fragment, {
    children: "워크스페이스 구성"
  })
}, {
  depth: 2,
  url: "#자동-워크스페이스-범위-지정",
  title: _jsx(_Fragment, {
    children: "자동 워크스페이스 범위 지정"
  })
}, {
  depth: 2,
  url: "#더-쉬운-마이그레이션",
  title: _jsx(_Fragment, {
    children: "더 쉬운 마이그레이션"
  })
}, {
  depth: 2,
  url: "#커뮤니티",
  title: _jsx(_Fragment, {
    children: "커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.8"
    }), "\n", "\n", _jsx(Date, {
      children: "Wednesday, February 22th, 2023"
    }), "\n", _jsx(Authors, {
      authors: ['gregsoltis', 'nathanhammond', 'tomknickman', 'anthonyshew', 'jaredpalmer', 'mehulkar', 'chrisolszewski', 'nicholasyang', 'alexanderlyon']
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 1.8은 ", _jsx(_components.code, {
        children: "turbo"
      }), "의 워크스페이스 이해를 개선하여 코드베이스에 더 나은 유연성과 더 많은 제어를 제공합니다."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#workspace-configurations",
          children: _jsx(_components.strong, {
            children: "워크스페이스 구성"
          })
        }), ": 이제 워크스페이스에 ", _jsx(_components.code, {
          children: "turbo.json"
        }), " 구성 파일을 추가하여 저장소의 루트 구성을 재정의할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#automatic-workspace-scoping",
          children: _jsx(_components.strong, {
            children: "자동 워크스페이스 범위 지정"
          })
        }), ": 이제 전역 ", _jsx(_components.code, {
          children: "turbo"
        }), "가 현재 워크스페이스를 자동으로 추론하여 해당 워크스페이스의 작업만 실행합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#easier-migrations",
          children: _jsx(_components.strong, {
            children: "더 쉬운 마이그레이션"
          })
        }), ": ", _jsx(_components.code, {
          children: "npx @turbo/codemod migrate"
        }), "를 사용하여 ", _jsx(_components.code, {
          children: "turbo"
        }), "의 새 버전으로 자동 마이그레이션합니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), "를 실행하여 오늘 업데이트하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "워크스페이스-구성",
      children: "워크스페이스 구성"
    }), "\n", _jsxs(_components.p, {
      children: ["워크스페이스 디렉토리에서 이제 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "을 추가하여 다음을 수행할 수 있습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "해당 워크스페이스에 특정한 작업 추가"
      }), "\n", _jsx(_components.li, {
        children: "작업에 대한 구성 재정의"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "이를 통해 팀은 전역 구성에서 벗어나 워크스페이스의 작업에 대한 세밀한 제어로 이동하여 모노레포의 프로젝트 소유권을 확장할 수 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: ["예를 들어, 모노레포에 Next.js 앱과 SvelteKit 앱이 있고 Turborepo를 사용하여 ", _jsx(_components.code, {
        children: "build"
      }), " 작업의 출력을 캐시하려고 한다고 상상해보세요. Next.js ", _jsx(_components.code, {
        children: "build"
      }), " 스크립트는 ", _jsx(_components.code, {
        children: ".next"
      }), " 디렉토리를 생성하는 반면 SvelteKit은 ", _jsx(_components.code, {
        children: ".svelte-kit"
      }), " 디렉토리를 생성합니다. 루트 ", _jsx(_components.code, {
        children: "outputs"
      }), "에 두 빌드 디렉토리를 모두 추가하는 대신 워크스페이스에서 ", _jsx(_components.code, {
        children: "outputs"
      }), " 키를 정의할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^codegen\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // 여기에서 outputs를 정의할 필요가 없습니다!"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "apps/my-nextjs-app/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // dependsOn은 루트에서 상속됩니다"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!.next/cache/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "apps/my-sveltekit-app/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // dependsOn은 루트에서 상속됩니다"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".svelte-kit/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["워크스페이스 구성의 ", _jsx(_components.code, {
        children: "extends"
      }), " 키를 사용하면 워크스페이스 소유자가 루트 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "의 장점을 사용하고 앱을 다르게 만드는 부분을 사용자 정의할 수 있습니다(", _jsx(_components.code, {
        children: "\"//\""
      }), " 기호는 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "루트에서 실행할 작업 정의"
      }), "에 익숙한 경우 익숙할 것입니다)."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "선언된"
      }), " 키는 해당 키가 존재하는 경우 루트의 키를 대체하여 루트 구성에 정의된 내용을 재정의합니다. ", _jsx(_components.strong, {
        children: "선언되지 않은"
      }), " 키는 루트 구성에서 상속됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["위의 예에서 ", _jsx(_components.code, {
        children: "outputs"
      }), "는 두 앱 모두에 대해 사용자 정의되는 반면 ", _jsx(_components.code, {
        children: "dependsOn"
      }), "은 루트 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 의해 구성되고 ", _jsx(_components.code, {
        children: "\"^codegen\""
      }), "으로 유지됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/structuring-a-repository#specifying-packages-in-a-monorepo",
        children: "문서에서 자세히 알아보기"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "자동-워크스페이스-범위-지정",
      children: "자동 워크스페이스 범위 지정"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/turbo-1-7-0",
        children: "Turborepo v1.7"
      }), "에서 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 전역으로 설치할 수 있게 되어 코드베이스의 어디에서나 작업을 실행할 수 있는 권한을 제공했습니다. 그러나 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 여전히 루트에서 작업을 실행하여 실행하려고 의도하지 않았을 수 있는 다른 워크스페이스의 작업을 실행했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["1.8에서 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 현재 작업 중인 워크스페이스를 자동으로 감지하고 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: [_jsx(_components.code, {
          children: "--filter"
        }), " 구문"]
      }), "을 생성하여 해당 워크스페이스로 작업 범위를 지정합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["예를 들어, 현재 디렉토리가 ", _jsx(_components.code, {
        children: "apps/admin"
      }), "이고 ", _jsx(_components.code, {
        children: "turbo build"
      }), " 명령을 사용하는 경우 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 후드 아래에서 ", _jsx(_components.code, {
        children: "turbo build --filter=admin"
      }), "을 실행하여 작업 중인 워크스페이스에 집중합니다."]
    }), "\n", _jsx(_components.h2, {
      id: "더-쉬운-마이그레이션",
      children: "더 쉬운 마이그레이션"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 버전을 업그레이드할 때 올바른 순서로 개별 codemod를 수동으로 실행할 필요가 없습니다. ", _jsx(_components.code, {
        children: "@turbo/codemod"
      }), "는 이제 저장소를 지정된 버전(기본적으로 ", _jsx(_components.code, {
        children: "latest"
      }), ")의 ", _jsx(_components.code, {
        children: "turbo"
      }), "로 업그레이드하고 ", _jsx(_components.em, {
        children: "필요한 모든 codemod를 실행"
      }), "하는 간단한 ", _jsx(_components.code, {
        children: "migrate"
      }), " 명령을 제공합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["지금 ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), "로 사용해 보세요."]
    }), "\n", _jsx(_components.h2, {
      id: "커뮤니티",
      children: "커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/turbo-1-7-0",
        children: "Turborepo v1.7"
      }), "을 출시한 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "19.6k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "주간 NPM 다운로드 987k"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel의 Remote Caching"
        }), "을 통해 42년의 컴퓨팅 시간 절약"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo를 여러분의 선택한 빌드 도구로 만들기 위한 지속적인 지원, 피드백 및 협력에 감사드립니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
